
import { Component, Vue } from "vue-property-decorator";
import NavigationMenu from "@/components/NavigationMenu.vue";

@Component({
  components: {
    NavigationMenu,
  },
})
export default class extends Vue {
  headerClass: string = "l_header";
  navBtnClass: string = "l_header_btn js-menu_btn";
  showNav: boolean = false;

  toggleNav() {
    if (!this.showNav) {
      this.navBtnClass = "l_header_btn js-menu_btn is_open";
    } else {
      this.navBtnClass = "l_header_btn js-menu_btn";
    }

    this.showNav = !this.showNav;
  }

  mounted() {
    window.addEventListener("scroll", this.onScroll);
  }

  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll() {
    if (window.pageYOffset > 80) {
      this.headerClass = "l_header is-follow";
    } else {
      this.headerClass = "l_header";
    }
  }
}
